import { Tag, Tags } from "@tryghost/content-api";
import { useEffect, useState } from "react";
import { useWindowSize } from "../../hooks/useWindowSize";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";
import { V3Dropdown } from "../Dropdown";
import { DropdownOptionCTA } from "../DropdownOptionCTA";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { BlogTagItem, BlogTagItemName, BlogTagsDisplayContainer, BlogTagsDisplayWrapper } from "./BlogTagsDisplay.styles";

const preferredOrder = ["All Articles", "Portfolio", "Backup", "Writers", "Journalists", "Content Marketers"];

export const FAKE_ALL_ARTICLES_TAG = {
    name: "All Articles",
    slug: "all",
    id: "",
    description: ""
} as Tag;

interface BlogTagsDisplayProps {
    tags: Tags;
    activeTag?: string;
}

export const BlogTagsDisplay = ({ tags, activeTag }: BlogTagsDisplayProps) => {
    const [ready, setReady] = useState(false);
    const [numTagsToRender, setNumTags] = useState(0);
    const size = useWindowSize();

    const tagsWithAllArticles = [FAKE_ALL_ARTICLES_TAG, ...tags].sort((a, b) => {
        const posA = preferredOrder.indexOf(a.name || "");
        const posB = preferredOrder.indexOf(b.name || "");
        if (posA < 0) return 1;
        if (posB < 0) return -1;
        return posA - posB;
    });

    useEffect(() => {
        if (!size.width) return;

        let elemWidth = 114;
        let counter = 0;

        while (elemWidth < size.width * 0.55 && counter < 6 && counter < tags.length) {
            elemWidth += 44 + 10 * (tags[counter]?.name || "").length;
            counter += 1;
        }

        setNumTags(counter);
    }, [size.width, tags]);

    useEffect(() => {
        setReady(true);
    }, []);

    const visibleTags = tagsWithAllArticles.slice(0, numTagsToRender);
    const hiddenTags = tagsWithAllArticles.slice(numTagsToRender, tags.length);

    if (!ready) return null;

    return (
        <BlogTagsDisplayWrapper>
            <BlogTagsDisplayContainer>
                {visibleTags.map((tag) => (
                    <UnstyledLink href={tag.id === "" ? APPLICATION_ROUTES.BLOG : `${APPLICATION_ROUTES.BLOG_TAG}/${tag.slug}`} key={tag.id}>
                        <BlogTagItem active={activeTag === tag.slug || (!activeTag && tag.id === "")}>
                            <BlogTagItemName>{tag.name}</BlogTagItemName>
                        </BlogTagItem>
                    </UnstyledLink>
                ))}
                <V3Dropdown
                    title={"Tags"}
                    renderReferenceElement={() => {
                        return (
                            <BlogTagItem>
                                <BlogTagItemName>More</BlogTagItemName>
                                <div>
                                    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.25 1.5L4 5L0.75 1.5"
                                            stroke="#ABB0BA"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                            </BlogTagItem>
                        );
                    }}
                    maxWidth={221}
                    renderPopperElement={(open) => {
                        if (!open) return <></>;

                        return (
                            <>
                                {hiddenTags.map((tag) => (
                                    <div key={tag.id}>
                                        <DropdownOptionCTA label={tag.name || ""} href={`${APPLICATION_ROUTES.BLOG_TAG}/${tag.slug}`} />
                                    </div>
                                ))}
                            </>
                        );
                    }}
                />
            </BlogTagsDisplayContainer>
        </BlogTagsDisplayWrapper>
    );
};
